import {Directive, ElementRef, HostListener, Input, Output} from '@angular/core';
import {Clip} from 'storyboard-renderer';
import {TimelineService} from '../../timeline.service';
import {DragService} from "../../../../shared/drag.service";

@Directive({
  selector: '[appExtendable]'
})
export class ExtendableDirective {


  @Input() clip: Clip;
  @Input() direction: string;
  @Input() clipComponent;

  constructor(public element: ElementRef, private dragService: DragService, private timelineService: TimelineService) { }

  @HostListener('touchend', ['$event'])
  @HostListener('document:mouseup', ['$event'])
  onMouseup(event) {
    event.stopPropagation();

    this.dragService.onDragMouseUp.next(event);

    event.preventDefault();
  }

  @HostListener('touchstart', ['$event'])
  @HostListener('mousedown', ['$event'])
  onMousedown(event: MouseEvent) {
    event.stopPropagation();

    const dragStartPosition = {x: DragService.getClientXFromEvent(event), y: DragService.getClientYFromEvent(event),
      element: {x: (<Element>event.target).clientLeft, y: this.elPos().top},
      clip: {length: this.clip.duration.as_milliseconds, position: this.clip.starts_at.as_milliseconds}};

    const direction = this.direction === 'right' ? DragService.DRAG_TYPE.CLIP_EXTEND_RIGHT : DragService.DRAG_TYPE.CLIP_EXTEND_LEFT;
    this.dragService.setDragElement(this.clipComponent, dragStartPosition, direction);

    this.dragService.setMouseDown((ev) => {
      this.timelineService.isClipExtending = true;
    });

    this.dragService.onDragMouseDown.next(event);

    event.preventDefault();
  }

  elPos() {
    return {
      top: parseInt(this.element.nativeElement.style.top, 10),
      left: parseInt(this.element.nativeElement.style.left, 10)
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/video-layer/directives/extendable.directive.ts